import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useLanguage } from "@/contexts/LanguageContext";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import Header from "@/components/Header";
import { Loader2 } from "lucide-react";

export default function AdminLogin() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const { t } = useLanguage();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username.trim() || !password.trim()) {
      toast.error(t("booking.fillAllFields"));
      return;
    }
    setLoading(true);
    try {
      await login(username, password);
      navigate("/admin");
    } catch (error) {
      toast.error(error.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-sand-50 flex flex-col">
      <Header />
      <main className="flex-1 flex items-center justify-center px-6 py-12">
        <Card className="w-full max-w-md bg-white rounded-2xl border-stone-200 shadow-sm">
          <CardHeader className="text-center pb-4">
            <div className="w-14 h-14 bg-forest-100 rounded-full flex items-center justify-center mx-auto mb-3">
              <img src="/lab-logo.png" alt="Logo" className="h-8 w-8" />
            </div>
            <CardTitle className="font-outfit text-xl text-forest-900">{t("admin.login")}</CardTitle>
            <CardDescription>{t("admin.loginDesc")}</CardDescription>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="space-y-1">
                <Label className="text-sm">{t("admin.username")}</Label>
                <Input placeholder={t("admin.usernamePlaceholder")} value={username} onChange={(e) => setUsername(e.target.value)} className="bg-stone-50 border-stone-200 rounded-xl" data-testid="username-input" />
              </div>
              <div className="space-y-1">
                <Label className="text-sm">{t("admin.password")}</Label>
                <Input type="password" placeholder={t("admin.passwordPlaceholder")} value={password} onChange={(e) => setPassword(e.target.value)} className="bg-stone-50 border-stone-200 rounded-xl" data-testid="password-input" />
              </div>
              <Button type="submit" disabled={loading} className="w-full bg-forest-800 hover:bg-forest-900 text-white rounded-full py-5" data-testid="login-btn">
                {loading ? <><Loader2 className="mr-2 h-4 w-4 animate-spin" />{t("admin.loggingIn")}</> : t("admin.loginBtn")}
              </Button>
            </form>
          </CardContent>
        </Card>
      </main>
    </div>
  );
}
